import React, { useState, useEffect } from 'react'
import Img from 'gatsby-image'
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import TabProducts from "../../../shared/components/molecules/tabProducts/tabProducts"
import BannerHome from "../../../shared/components/molecules/bannerhome/bannerhome"
import OthersEvents from "../../../shared/components/molecules/others-events/others-events"
import RichText from '../../../shared/components/atoms/rich-text/rich-text'
import ConsultingOutstading from "../../../shared/components/molecules/consulting-outstading/consulting-outstading"
import LeafletCard from '../../../shared/components/molecules/leaflet-card/leaflet-card'
import CardProduct from '../../../shared/components/molecules/cardProduct/cardProduct'
import Slider from "react-slick"
import ModalRetails from './../../../shared/components/molecules/modal-retails/modal-retails'
import ProductService from '../../../shared/services/products'
import Button from '../../../shared/components/atoms/Button/Button';
import SessionService from "../../../shared/services/session"
import Faq from '../../../shared/components/molecules/faq/faq'
import useSessionState from '../../../shared/hooks/useSessionState'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { dataLayerUserInfo } from '../../../shared/utils/userInfo'
import './product-line-content.scss'
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

const QualifyProductContent = props => {
    const { slug, sectionInfo, menuInfo, isMobile } = props
    const { homeLink } = useHomeLinkMode();
    const [listLikes, setlistLikes] = useState(null)
    const [localLikes, setlocalLikes] = useState([])
    const [modalShop, setModalShop] = useState(false);
    const { isLoggedUser } = useSessionState();
    const newSlug = slug.substring(slug.lastIndexOf('/') + 1);
    const optionIsInMenu = menuInfo?.filter(option => option?.slug.includes(newSlug))[0]

    //products likes
    const handleLoadLikes = () => {
        if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) { //Verify if is user logged
            ProductService.getAnomLikes().then(res => {
                setlistLikes(res.data)
            }).catch(e => console.log(e))
        } else {
            localStorage.removeItem('LOCAL_LIKES_PRODUCTS');
            const config = {
                headers: {
                    Authorization: SessionService.getIdTokenData(),
                },
            }

            ProductService.getAuthLikes(config).then(res => {
                for (let index = 0; index < res.data.length; index++) {
                    if (res.data[index].userLike) {
                        if (localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null) {
                            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_PRODUCTS"))
                            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS)))
                            setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
                        } else {
                            localStorage.setItem('LOCAL_LIKES_PRODUCTS', JSON.stringify([res.data[index].idCMS]))
                            setlocalLikes([res.data[index].idCMS])
                        }
                    }
                }
                setlistLikes(res.data)
            }).catch(e => console.log(e))
        }
    }

    const isLiked = (idProduct, list) => {
        let i
        for (i = 0; i < list.length; i++) {
            if (list[i] === idProduct) {
                return true;
            }
        }

        return false;
    }

    const getProductAtr = (idProduct, list) => {
        let i
        for (i = 0; i < list.length; i++) {
            if (list[i].idCMS === idProduct) {
                return list[i];
            }
        }

        return false;
    }

    const listProducts = sectionInfo?.productos?.map((producto, index) => {
        producto.imagenProducto = producto.imagenProductoPrevisualizacion
        let incontinencia = producto?.tipoDeIncontinencia ? producto?.tipoDeIncontinencia[0].nombreDeEtiqueta : ''
        let categoria = producto?.categorias ? producto?.categorias[0]?.titulo : ''
        let dataLayerValue = {
            'list': sectionInfo.titulo,
            'id': producto.codigoDeProducto,
            'name': producto.nombreProducto,
            'brand': 'TENA',
            'category': categoria,
            'variant': incontinencia,
            'position': index
        }
        const gtagValue={item_id: producto.codigoDeProducto,
        item_name: producto.nombreProducto,
        affiliation: 'Tena Online',
        item_brand: 'Tena',
        item_category: categoria,        
        currency: process.env.LOCALE,
        }
        
        return <CardProduct
            dataLayerbody={gtagValue}
            isFreeSamples={false}
            samples={[]}
            noHeight={false}
            noFooter={false}
            slug={"productos"}
            producto={producto}
            key={index}
            isSent={false}
            idProduct={producto.codigoDeProducto}
            likesInfo={
                listLikes !== null &&
                getProductAtr(producto.codigoDeProducto, listLikes)
            }
            setlistLikes={setlistLikes}
            setlocalLikes={setlocalLikes}
            isLocalLiked={isLiked(producto.codigoDeProducto, localLikes)}
            setModalShop={() => {
                setModalShop(producto)
            }}
            onClick={(e) => {
                e.preventDefault()
            }}
        />
    }) || []

    const settings = {
        dots: true,
        infinite: false,
        autoplay: false,
        speed: 1500,
        autoplaySpeed: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: true,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]

    }

    const datalayerPush = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(event)
    }

    const userInfo=dataLayerUserInfo()
	const dataLayerConocerMas = () => {      
			let location=''
			if (window) {
					location= window.location.href
			}
			pushDataLayerEvent({event: 'Interacciones - Productos',
			category: 'productos',
			action: 'click',
			label: 'Conocer más',
			location: location,
			user_data: userInfo.user_data? userInfo.user_data: '',
			log_status: userInfo.log_status,})
	}


    const dataLayerBanner = ({ slide, index }) => {
        datalayerPush({
            'event': 'promoClick',
            'promo': {
                'id': "https:" + slide?.bannerDesktop?.file?.url,
                'name': slide?.titulo,
                'creative': 'slider :: ' + sectionInfo.titulo,
                'position': index
            }
        })
    }

    const dataLayerOutstandingBanner = (info) => {
        //if banner has link
    }
    
    useEffect(() => {
        handleLoadLikes();
        setlocalLikes(localStorage.getItem('LOCAL_LIKES_PRODUCTS') !== null ? JSON.parse(localStorage.getItem('LOCAL_LIKES_PRODUCTS')) : [])
    }, [])

    return (process.env.LOCALE === 'es-PE'?
    (<section className="f-product-line" style={{ "--color": sectionInfo.colorPrincipal }}>
    {modalShop &&
        <ModalRetails
            productInfo={modalShop}
            paramRetails={modalShop?.retailsDelProducto}
            hideAction={() => {
                setModalShop(false)
            }}
        />
    }

    <div className="f-product-line__container">
        <TabProducts
            title="LINEAS DE PRODUCTOS"
            slug={slug}
            tabs={{ opcionesMenu: menuInfo }}
        />
        {optionIsInMenu && 
        <h1 className="f-title-product-line" >{optionIsInMenu.nombre}</h1>
        }
    </div>

    <div className="f-product-line__container--space f-product-line__banner">
        <BannerHome
            array={sectionInfo.banner}
            ismobile={isMobile}
            sliderConfig={{
                autoplay: false,
            }}
            dataLayer={dataLayerBanner}
        />
    </div>

    <div className="f-product-line__container f-product-line__container--space f-product-line__products">
        <h2 className="f-title">{sectionInfo.tituloProductos}</h2>

        <RichText
            jsonInfo={sectionInfo.descripcionProductos.json}
            className="f-product-line__products__description"
        />

        <Slider {...settings} className="f-product-line__products__slider">
            {listProducts}
        </Slider>

        <Button
            text={sectionInfo.ctaProductos}
            type="button"
            classname="f-button f-button--primary"
            onClickAction={() => {
                dataLayerConocerMas()
                window.location.href = homeLink + sectionInfo.ctaRedireccionProductos
            }}
        />
    </div>

    <div className="f-product-line__faq">
        <RichText
            jsonInfo={sectionInfo.informacionParaTuInteres.json}
            className="f-product-line__faq__description"
        />

        <Faq
            content={{
                preguntasFrecuentes: sectionInfo.paraTuInteres
            }}
        />
    </div>

    <div className="f-product-line__container--space f-product-line__banner">
        {sectionInfo.slugRedireccinBannerDestacado ?
        <a href={sectionInfo.slugRedireccinBannerDestacado} alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}>
            <Img
                className="f-product-line__banner__image"
                fluid={sectionInfo.bannerDestacado[isMobile ? 1 : 0].fluid}
                alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}
                onCLick={dataLayerOutstandingBanner}
            />
        </a>
        :
        <Img
                className="f-product-line__banner__image"
                fluid={sectionInfo.bannerDestacado[isMobile ? 1 : 0].fluid}
                alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}
                onCLick={dataLayerOutstandingBanner}
            />}                
    </div>

    <div className="f-product-line__other-events">
        <OthersEvents
            othersEvents={sectionInfo.eventos}
            haveTitle={false}
        />
    </div>

    <div className="f-product-line__container f-product-line__consulting">
        <ConsultingOutstading
            consultingOutstading={
                {
                    info: isMobile ? sectionInfo.informacionConsultorioVirtualMobile : sectionInfo.informacionConsultorioVirtual,
                    images: sectionInfo.imagenConsultorioVirtual,
                    cta: sectionInfo.ctaConsultorios,
                    ctaRedirection: sectionInfo.ctaRedireccionConsultorios
                }}
            ismobile={isMobile}
        />
    </div>

    {isLoggedUser ? null :
        <div className="f-product-line__container f-product-line__container--space">
            <LeafletCard
                isMobile={isMobile}
                productLine={sectionInfo.titulo}
            />
        </div>
    }
</section>)
        :
        (<section className="f-product-line" style={{ "--color": sectionInfo.colorPrincipal }}>
            {modalShop &&
                <ModalRetails
                    productInfo={modalShop}
                    paramRetails={modalShop?.retailsDelProducto}
                    hideAction={() => {
                        setModalShop(false)
                    }}
                />
            }

            <div className="f-product-line__container">
                <TabProducts
                    title="LINEAS DE PRODUCTOS"
                    slug={slug}
                    tabs={{ opcionesMenu: menuInfo }}
                />
                {optionIsInMenu && 
                <h1 className="f-title-product-line" >{optionIsInMenu.nombre}</h1>
                }
            </div>

        

            <div className="f-product-line__container--space f-product-line__banner">
                <BannerHome
                    array={sectionInfo.banner}
                    ismobile={isMobile}
                    sliderConfig={{
                        autoplay: false,
                    }}
                    dataLayer={dataLayerBanner}
                />
            </div>

            <div className="f-product-line__other-events">
                <OthersEvents
                    othersEvents={sectionInfo.eventos}
                    haveTitle={false}
                />
            </div>

            <div className="f-product-line__container--space f-product-line__banner">
                {sectionInfo.slugRedireccinBannerDestacado ?
                <a href={sectionInfo.slugRedireccinBannerDestacado} alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}>
                    <Img
                        className="f-product-line__banner__image"
                        fluid={sectionInfo.bannerDestacado[isMobile ? 1 : 0].fluid}
                        alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}
                        onCLick={dataLayerOutstandingBanner}
                    />
                </a>
                :
                <Img
                        className="f-product-line__banner__image"
                        fluid={sectionInfo.bannerDestacado[isMobile ? 1 : 0].fluid}
                        alt={sectionInfo.bannerDestacado[isMobile ? 1 : 0].description}
                        onCLick={dataLayerOutstandingBanner}
                    />}                
            </div>

            <div className="f-product-line__container f-product-line__container--space f-product-line__products">
                <h2 className="f-title">{sectionInfo.tituloProductos}</h2>

                <RichText
                    jsonInfo={sectionInfo.descripcionProductos.json}
                    className="f-product-line__products__description"
                />

                <Slider {...settings} className="f-product-line__products__slider">
                    {listProducts}
                </Slider>

                <Button
                    text={sectionInfo.ctaProductos}
                    type="button"
                    classname="f-button f-button--primary"
                    onClickAction={() => {
                        dataLayerConocerMas()
                        window.location.href = homeLink + sectionInfo.ctaRedireccionProductos
                    }}
                />
            </div>

            <div className="f-product-line__faq">
                <RichText
                    jsonInfo={sectionInfo.informacionParaTuInteres.json}
                    className="f-product-line__faq__description"
                />

                <Faq
                    content={{
                        preguntasFrecuentes: sectionInfo.paraTuInteres
                    }}
                />
            </div>

            <div className="f-product-line__container f-product-line__consulting">
                <ConsultingOutstading
                    consultingOutstading={
                        {
                            info: isMobile ? sectionInfo.informacionConsultorioVirtualMobile : sectionInfo.informacionConsultorioVirtual,
                            images: sectionInfo.imagenConsultorioVirtual,
                            cta: sectionInfo.ctaConsultorios,
                            ctaRedirection: sectionInfo.ctaRedireccionConsultorios
                        }}
                    ismobile={isMobile}
                />
            </div>

            {isLoggedUser ? null :
                <div className="f-product-line__container f-product-line__container--space">
                    <LeafletCard
                        isMobile={isMobile}
                        productLine={sectionInfo.titulo}
                    />
                </div>
            }
        </section>)
    )
}

export default QualifyProductContent